// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ntextarea[data-v-f7c5016a]{\n    min-height: 150px;\n    max-height: 500px;\n}\n", ""]);
// Exports
module.exports = exports;
